// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-payment-css-PDFView__embed--w1w9Y{flex:1;width:100%;height:420px}`, "",{"version":3,"sources":["webpack://./src/payment/css/PDFView.scss"],"names":[],"mappings":"AAAA,uCACC,MAAA,CACA,UAAA,CACA,YAAA","sourcesContent":[".embed {\r\n\tflex: 1;\r\n\twidth: 100%;\r\n\theight: 420px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"embed": `src-payment-css-PDFView__embed--w1w9Y`
};
export default ___CSS_LOADER_EXPORT___;
